import { IStatusHandler, SnackbarState } from "@/interfaces/ui.interface"

export default {
  setSnackbar(state: SnackbarState, payload: Partial<SnackbarState['snackbar']>) {
    state.snackbar = {
      ...state.snackbar,
      show: true,
      ...payload
    }
  },
  closeSnackbar(state: SnackbarState) {
    state.snackbar.show = false
  },
  setStatusResponse(state: IStatusHandler, payload: Partial<IStatusHandler['status']>) {
    state.status = {
      ...state.status,
      ...payload
    }
  }
}